interface TitleBlock {
  id?: string;
  type?: string;
  data?: { header?: string | null; paragraph?: string | null } | null;
}

export interface TitlePost {
  username?: string;
  textBlocks?: TitleBlock[] | null;
}

const MAX_EXCERPT = 80;

export function extractPostTitle(
  post: TitlePost | null,
  postId: string,
): string {
  const blocks = post?.textBlocks ?? [];

  const heading = blocks.find((b) => b?.type === 'Heading');
  const headingText = heading?.data?.header?.trim();
  if (headingText) return headingText;

  const paragraph = blocks.find((b) => b?.type === 'Paragraph');
  const paraText = paragraph?.data?.paragraph?.trim();
  if (paraText) {
    return paraText.length > MAX_EXCERPT
      ? `${paraText.slice(0, MAX_EXCERPT).trimEnd()}…`
      : paraText;
  }

  if (post?.username) return `@${post.username}`;
  return postId;
}
